import { EditMachinery } from 'pages/Machinery/EditMachinery'
import { EditLocation } from './../pages/Locations/EditLocation'
import { EditEmployee } from 'pages/Employees/EditEmployee'
import { Shifts } from 'pages/Shifts/Shifts'
import { Zones } from 'pages/Zones/Zones'
import { Employees, Machinery, Schedule } from '../pages'
import { AddEmployeer } from '../pages/Employees/AddEmployee'
import { AddItem } from '../pages/Inventory/Items/AddItem'
import { InventoryItems } from '../pages/Inventory/Items/InventoryItems'
import { AddSupplier } from '../pages/Inventory/Suppliers/AddSupplier'
import { InvetorySuppliers } from '../pages/Inventory/Suppliers/InvetorySuppliers'
import { AddMachinery } from '../pages/Machinery/AddMachinery'
import { SingleMachineryCategory } from '../pages/Machinery/SingleMachineryCategory'
import { Locations } from 'pages/Locations/Locations'
import { AddLocation } from 'pages/Locations/AddLocation'
import { Departments } from 'pages/Departments/Departments'
import { EditDepartment } from 'pages/Departments/EditDepartment'
import { AddDepartment } from 'pages/Departments/AddDepartment'
import { EditItem } from 'pages/Inventory/Items/EditItem'
import { EditSupplier } from 'pages/Inventory/Suppliers/EditSupplier'
import { Costs } from 'pages/Finances/Costs/Costs'
import { Reports } from 'pages/Reports/Reports'
import { GlobalView } from 'pages/GlobalView/GlobalView'
import { SingleReport } from 'pages/Reports/SingleReport'
import { ClientDashboard } from 'pages/Dashboard/Dashboard'
import { DBEmployees } from 'pages/Dashboard/DashboardEmplyees/DBEmployees'
import { DBTasks } from 'pages/Dashboard/DashboardTasks/DBTasks'
import { DBSingleTask } from 'pages/Dashboard/DashboardTasks/DBSingleTask'
import { DBMachines } from 'pages/Dashboard/DashboardMachines/DBMachines'
import { DBSingleMachine } from 'pages/Dashboard/DashboardMachines/DBSingleMachine'
import { AddRole } from 'pages/ResourcesAdmin/Roles/AddRole'
import { EditRole } from 'pages/ResourcesAdmin/Roles/EditRole'
import { ClientRoles } from 'pages/ResourcesAdmin/Roles/ClientRoles'
import { SingleRole } from 'pages/ResourcesAdmin/Roles/SingleRole'
import { DBTaskCycles } from 'pages/Dashboard/DashboardTasks/DBTaskCycles'
import { DBWorkflows } from 'pages/Dashboard/DashboardTasks/DBWorkflows'
import { Tasks } from 'pages/Tasks/Tasks'
import { AddTask } from 'pages/Tasks/AddTask'
import { ViewTask } from 'pages/Tasks/ViewTask'
import { FuelManagement } from 'pages/FuelManagement/FuelManagement'
import { AddFuelTask } from 'pages/FuelManagement/AddFuelTask'
import { Food } from 'pages/Food/Food'
import { FoodItems } from 'pages/Food/FoodItems/FoodItems'
import { FoodCategories } from 'pages/Food/FoodCategories/FoodCategories'
import { Transportation } from 'pages/Transportation/Transportation'
import { Accommodation } from 'pages/Accomodation/Accommodation'
import { WorkScheduleModels } from 'pages/Shifts/WorkScheduleModels'
import { Payrolls } from 'pages/Payrolls/Payrolls'
import { Attendance } from 'pages/Attendance/Attendance'
import { HrDashboard } from 'pages/HrDashboard/HrDashboard'
import { DBSingleEmployee } from 'pages/Dashboard/DashboardEmplyees/DBSingleEmployee'
import { InventoryCostCenter } from 'pages/Inventory/CostCenter/InventoryCostCenter'
import { InventoryReceipts } from 'pages/Inventory/Receipts/InventoryReceipts'
import { AddReceipt } from 'pages/Inventory/Receipts/AddReceipt'
import { SingleReceipt } from 'pages/Inventory/Receipts/SingleReceipt'
import { InventoryDashboard } from 'pages/Inventory/Dashboard/InventoryDashboard'
import { InventoryRequests } from 'pages/Inventory/Requests/InventoryRequests'
import { AddInventoryRequest } from 'pages/Inventory/Requests/AddInventoryRequest'
import { SelectedDishes } from 'pages/Food/SelectedDishes/SelectedDishes'
import { FuelTanks } from 'pages/FuelManagement/Tanks/FuelTanks'
import { FuelTypes } from 'pages/FuelManagement/Types/FuelTypes'
import { FuelSuppliers } from 'pages/FuelManagement/Suppliers/FuelSuppliers'
import { FuelMachines } from 'pages/FuelManagement/Machines/FuelMachines'
import { FuelDispenses } from 'pages/FuelManagement/Dispenses'
import { FuelBatches } from 'pages/FuelManagement/Batches'
import { InventoryTransfers } from 'pages/Inventory/Transfers/InventoryTransfers'
import { InventoryIssues } from 'pages/Inventory/Issues/InventoryIssues'
import { ViewAccommodation } from 'pages/Accomodation/ViewAccommodation'
import { AccommodationUsers } from 'pages/Accomodation/AccommodationUsers'
import { FuelLosses } from 'pages/FuelManagement/FuelLosses/FuelLosses'
import { FoodCompanySettings } from 'pages/Food/FoodCompanySettings'
import { FoodEligibleEmployees } from 'pages/Food/FoodEligibleEmployees'
import { AdHocFoodProvisioning } from 'pages/Food/ProvisioningRecords/AdHocFoodProvisioning'
import { TransportationEmployees } from 'pages/Transportation/TransportationEmployees'
import { TransportationDailyIntents } from 'pages/Transportation/TransportationDailyIntents'
import { StandByFoodProvisioning } from 'pages/Food/ProvisioningRecords/StandByFoodProvisioning'
import { ProvisioningRecords } from 'pages/Food/ProvisioningRecords/ProvisioningRecords'

export const clientRoutes = [
  {
    path: 'hr/',
    Component: HrDashboard,
  },
  {
    path: 'hr/dashboard',
    Component: HrDashboard,
  },
  {
    path: '/global-view',
    Component: GlobalView,
  },
  {
    path: '/hr',
    Component: HrDashboard,
  },
  {
    path: '/dashboard',
    Component: ClientDashboard,
  },
  {
    path: '/dashboard/employees',
    Component: DBEmployees,
  },
  {
    path: '/dashboard/employees/:id',
    Component: DBSingleEmployee,
  },
  {
    path: '/dashboard/tasks',
    Component: DBTasks,
  },
  {
    path: '/dashboard/cycles',
    Component: DBTaskCycles,
  },
  {
    path: '/dashboard/tasks/:id',
    Component: DBSingleTask,
  },
  {
    path: '/dashboard/machines',
    Component: DBMachines,
  },
  {
    path: '/dashboard/machines/:id',
    Component: DBSingleMachine,
  },

  {
    path: '/dashboard/workflows',
    Component: DBWorkflows,
  },
  {
    path: '/fuel',
    Component: FuelManagement,
  },
  {
    path: '/fuel/dashboard',
    Component: FuelManagement,
  },
  {
    path: '/fuel/fuel-tasks/add',
    Component: AddFuelTask,
  },
  {
    path: '/fuel/tanks',
    Component: FuelTanks,
  },
  {
    path: '/fuel/losses',
    Component: FuelLosses,
  },
  {
    path: '/fuel/types',
    Component: FuelTypes,
  },
  {
    path: '/fuel/dashboard/machines',
    Component: FuelMachines,
  },
  {
    path: '/fuel/dashboard/batches',
    Component: FuelBatches,
  },
  {
    path: '/fuel/dashboard/dispenses',
    Component: FuelDispenses,
  },
  {
    path: '/fuel/suppliers',
    Component: FuelSuppliers,
  },
  {
    path: '/hr/employees',
    Component: Employees,
  },
  {
    path: 'hr/employees/add',
    Component: AddEmployeer,
  },
  {
    path: '/hr/food',
    Component: Food,
  },
  {
    path: '/hr/food/items',
    Component: FoodItems,
  },
  {
    path: '/hr/accommodation',
    Component: Accommodation,
  },
  {
    path: '/hr/accommodation/users',
    Component: AccommodationUsers,
  },

  {
    path: '/hr/accommodation/:id',
    Component: ViewAccommodation,
  },
  {
    path: '/hr/transportation',
    Component: Transportation,
  },
  {
    path: '/hr/transportation/employees',
    Component: TransportationEmployees,
  },
  {
    path: '/hr/transportation/daily-intents',
    Component: TransportationDailyIntents,
  },
  {
    path: '/hr/food/categories',
    Component: FoodCategories,
  },
  {
    path: '/hr/food/selected-dishes',
    Component: SelectedDishes,
  },
  {
    path: '/hr/food/company-settings',
    Component: FoodCompanySettings,
  },
  {
    path: '/hr/food/provisioning',
    Component: ProvisioningRecords,
  },
  {
    path: '/hr/food/eligible-employees',
    Component: FoodEligibleEmployees,
  },
  {
    path: '/hr/food/provisioning/ad-hoc',
    Component: AdHocFoodProvisioning,
  },
  {
    path: '/hr/food/provisioning/standby',
    Component: StandByFoodProvisioning,
  },
  {
    path: '/hr/payrolls',
    Component: Payrolls,
  },
  {
    path: '/hr/roles/add',
    Component: AddRole,
  },
  {
    path: '/hr/roles/:id',
    Component: SingleRole,
  },
  {
    path: '/hr/roles/:id/edit',
    Component: EditRole,
  },
  {
    path: '/hr/roles',
    Component: ClientRoles,
  },
  {
    path: '/hr/employees/:id/edit',
    Component: EditEmployee,
  },
  {
    path: '/hr/schedule',
    Component: Schedule,
  },
  {
    path: '/hr/schedule/shifts',
    Component: Shifts,
  },
  {
    path: '/hr/schedule/work-schedule-models',
    Component: WorkScheduleModels,
  },
  {
    path: '/hr/attendance',
    Component: Attendance,
  },
  {
    path: 'machinery',
    Component: Machinery,
  },
  {
    path: 'machinery/add',
    Component: AddMachinery,
  },
  {
    path: 'machinery/:id',
    Component: SingleMachineryCategory,
  },
  {
    path: 'machinery/:categoryId/:id',
    Component: EditMachinery,
  },
  {
    path: 'inventory/items',
    Component: InventoryItems,
  },
  {
    path: 'inventory/cost-center',
    Component: InventoryCostCenter,
  },
  {
    path: 'inventory/receipts',
    Component: InventoryReceipts,
  },
  {
    path: 'inventory/receipts/add',
    Component: AddReceipt,
  },
  {
    path: 'inventory/receipts/:id',
    Component: SingleReceipt,
  },
  {
    path: 'inventory/dashboard',
    Component: InventoryDashboard,
  },
  {
    path: 'inventory/items/add',
    Component: AddItem,
  },
  {
    path: 'inventory/items/edit/:id',
    Component: EditItem,
  },
  {
    path: 'inventory/requests',
    Component: InventoryRequests,
  },
  {
    path: 'inventory/requests/add',
    Component: AddInventoryRequest,
  },
  {
    path: 'inventory/supliers',
    Component: InvetorySuppliers,
  },
  {
    path: 'inventory/transfers',
    Component: InventoryTransfers,
  },
  {
    path: 'inventory/issues',
    Component: InventoryIssues,
  },
  {
    path: 'inventory/supliers/add',
    Component: AddSupplier,
  },
  {
    path: 'inventory/supliers/:id',
    Component: EditSupplier,
  },
  {
    path: 'resources',
    Component: Locations,
  },
  {
    path: 'resources/locations',
    Component: Locations,
  },
  {
    path: 'resources/locations/add',
    Component: AddLocation,
  },
  {
    path: 'resources/locations/edit/:id',
    Component: EditLocation,
  },
  {
    path: 'analytics',
    Component: Reports,
  },
  {
    path: 'analytics/reports',
    Component: Reports,
  },
  {
    path: 'analytics/report/:id',
    Component: SingleReport,
  },
  {
    path: 'resources/zones',
    Component: Zones,
  },
  {
    path: 'hr/departments',
    Component: Departments,
  },
  {
    path: 'hr/departments/:id',
    Component: EditDepartment,
  },
  {
    path: 'hr/departments/add',
    Component: AddDepartment,
  },
  {
    path: 'analytics/costs',
    Component: Costs,
  },
  {
    path: 'tasks',
    Component: Tasks,
  },
  {
    path: 'tasks/add',
    Component: AddTask,
  },
  {
    path: 'tasks/:id',
    Component: ViewTask,
  },
]
